import React, { Fragment } from "react"
import { Button, Divider, Form, Input, InputNumber, Progress, Radio, Row, Space, Typography } from "antd";
import { EuroOutlined } from "@ant-design/icons"
import { currencyFormater, getCurrencyFormater, getDeviseSymbol } from "../../i18n";
import { t } from "@lingui/core/macro"
import { Trans } from "@lingui/react/macro"

const { Text } = Typography

export default class Dette extends React.Component {

    render() {
        const { config, context, devise } = this.props

        const dette = config.dette

        const payed = dette.montant - dette.reste
        const percent = payed * 100 / dette.montant

        const currencyFormater = getCurrencyFormater(context)

        return (
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column", padding: "20px 0%" }}>
                <Form.Item noStyle shouldUpdate={true}>
                    {(form) => (
                        <Fragment>

                            <Form.Item
                                label={t`Montant`}
                                name="montant"
                                rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                            >
                                <InputNumber
                                    size="large"
                                    min={1}
                                    placeholder={t`Montant`}
                                    addonAfter={
                                        form.getFieldValue("abo")
                                            ? (
                                                <Space>
                                                    {getDeviseSymbol(context, devise)} <Trans>/ Mois</Trans>
                                                </Space>
                                            )
                                            : getDeviseSymbol(context, devise)
                                    }
                                />
                            </Form.Item>

                            <Text>
                                <Trans>Reste</Trans> : {currencyFormater(dette.reste, 0, devise)}
                            </Text>

                            <Progress
                                percent={parseInt(percent)}
                                status="active"
                                strokeColor={{
                                    from: '#833ab4',
                                    to: '#c53cd4',
                                }}
                            />

                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: 20
                            }}>
                                <Radio.Group
                                    value={form.getFieldValue("abo")}
                                    optionType="button"
                                    buttonStyle="solid"
                                    onChange={(e => form.setFieldValue("abo", e.target.value))}
                                >
                                    <Radio value={false}><Trans>En une fois</Trans></Radio>
                                    <Radio value={true}><Trans>En plusieurs fois</Trans></Radio>
                                </Radio.Group>
                            </div>

                        </Fragment>
                    )}
                </Form.Item>
            </div>

        )
    }
}
